import { IEvent } from "#webapp/src/__schema__";
import { getEventTime } from "@clockwise/client-commons/src/util/event-recurrence";
import { EFlex, getFlexFromEvent } from "@clockwise/client-commons/src/util/event-tag";
import { getRenderTimeZone } from "@clockwise/web-commons/src/util/time-zone.util";
import { EventFlexibility } from "@clockwise/web-commons/src/util/use-event-flexibility.util";

const getEventRecurrenceDescription = (event: IEvent, eventFlexibility: EventFlexibility) => {
  let recurrence: string | undefined;
  let dayOfWeekFlexibilityEligible = false;
  let eventFlexibilityDescription: string | null | undefined = "";

  dayOfWeekFlexibilityEligible = Boolean(
    eventFlexibility.eventFlexibilityConstraints?.dayOfWeekFlexibilityEligible,
  );
  eventFlexibilityDescription = eventFlexibility.eventFlexibility?.description;

  const flex = getFlexFromEvent(event, true); // flexibility from org-tag
  const eventTime = String(getEventTime(event, getRenderTimeZone())); // the current recurrence string for event

  if (flex === EFlex.Pin) {
    recurrence = eventTime;
  } else if (dayOfWeekFlexibilityEligible) {
    recurrence = eventFlexibilityDescription || "";
  }

  return recurrence;
};

export default getEventRecurrenceDescription;
